<template lang="pug">
#layout(:class='name')
  .wrapper.centered(:class="{ 'nav-open' : navOpened }")
    sidebar(:open='navOpened')
    .main-panel(:class="{ 'loading' : loading }")
      ed-meta-nav
      navigation(@toggleSideBar='toggleSideBar')
      slot
      md-footer
      .close-layer(v-if='navOpened', @click='onCloseLayerClick')
</template>

<script>

import Navigation from '@/components/Navigation'
import MdFooter from '@/components/Footer'
import Sidebar from '@/components/Sidebar'

export default {
  components: {
    Navigation,
    MdFooter,
    Sidebar
  },
  data() {
    return {
      name: 'layout-navigation',
      sidebarToggled: false
    }
  },
  computed: {
    navOpened() {
      return this.sidebarToggled
    },
    loading() {
      return this.$loading
    }
  },
  methods: {
    toggleSideBar() {
      this.sidebarToggled = !this.sidebarToggled
    },
    onCloseLayerClick() {
      this.toggleSideBar()
    }
  }
}

</script>



// WEBPACK FOOTER //
// main.vue?20a66f74